module.exports = {
  main: '首页',
  home: '工作台',
  info: '个人信息',
  log: '资金日志',
  bill: '我的帐单',
  address: '我的地址',
  ticket: '我的发票',
  
  cex_menu: 'Cex模块',
  cex: '开始下单',
  cex_order: '我的订单',
  cex_take: '我的取件'
}